import * as React from 'react';
import {View} from 'react-native';

import Screen from '../../shared/components/screen';

import {Props} from './model';
import {Routes, Screens} from '../../shared/routing';
import {Breadcrumbs} from '../../shared/components/breadcrumbs';
import {SocialSupportList} from '../../shared/components/socialSupportList';
import {useStyles} from '../../shared/hooks/styles';
import {ResponsiveView} from '../../shared/components/responsiveView';
import {DeviceSize} from '../../shared/theme/helpers';
import {Text} from '../../shared/components/text';
import {CustomScrollView} from '../../shared/components/scrollView';

const routes = [
  {
    title: 'Меры социальной поддержки',
    routeName: Screens.SocialSupportMeasures,
    webRoute: Routes.socialSupportMeasures,
  },
  {
    title: 'Государственные программы',
    routeName: Screens.StatePrograms,
    webRoute: Routes.statePrograms,
  },
];

export default ({socialSupportData, title}: Props) => {
  const styles = useStyles(({theme, isDesktop}) => ({
    sectionContainer: {
      marginTop: 32,
      paddingHorizontal: 24,
      marginBottom: theme.screen.bottomOffset - (isDesktop ? 30 : 20),
    },
    sectionTitle: {
      ...theme.fonts.h2,
      marginBottom: 40,
      marginTop: 40,
    },
    accordionStyle: {padding: 0},
  }));

  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <View>
          <View style={styles.sectionContainer}>
            <Breadcrumbs routes={routes} />
            <ResponsiveView only={[DeviceSize.desktop]}>
              <Text style={styles.sectionTitle}>{title}</Text>
            </ResponsiveView>
            <SocialSupportList data={socialSupportData} />
          </View>
        </View>
      </CustomScrollView>
    </Screen>
  );
};
